import { Logger } from "./Logger";
export class EventFiringClient {
    constructor(name, handlers = null) {
        this.log = new Logger(name);
        this._cleanEventHandlers();
        if (handlers) {
            this._setEventHandlers(handlers);
        }
    }
    /**
     * Sets event handler callbacks.
     *
     * Every event handler callback defaults to _defaultHandlers which just prints the event to
     * console.
     *
     * An event callback that was not passed in the argument,
     * will default to either:
     * - the previous callback is ever set.
     * - the _defaultHandlers's corresponding callback.
     *
     * The default behaviour when appendToPrevious = true is to append the handlers passed in the
     * arguments.
     *
     * If appendToPrevious is set to false the previous handlers will be cleaned before we the the
     * argument handlers.
     */
    _setEventHandlers(handlers) {
        if (!handlers) {
            throw new Error("Invalid handlers: " +
                handlers +
                ", set the handlers object " +
                " containing the event callbacks you wish to receive events for." +
                " eg {onConnected: () => {}}");
        }
        this.log.info("setEventHandlers: handlers passed: ", handlers);
        this._cleanEventHandlers();
        for (const handlerName in handlers) {
            if (this._eventHandlers[handlerName]) {
                this.log.info("setEventHandlers: setting handler: " + handlerName);
                if (!this._realEventHandlers[handlerName]) {
                    this._realEventHandlers[handlerName] = [handlers[handlerName]];
                }
                else {
                    this._realEventHandlers[handlerName].push(handlers[handlerName]);
                }
                // @ts-ignore
                this._eventHandlers[handlerName] = (ev) => {
                    // log before firing an event.
                    if (ev) {
                        if (!ev.error) {
                            this.log.info(handlerName, ev);
                        }
                        else {
                            this.log.error(handlerName, ev);
                        }
                    }
                    else {
                        this.log.info(handlerName);
                    }
                    this._realEventHandlers[handlerName].forEach((handler) => {
                        try {
                            handler(ev);
                        }
                        catch (error) {
                            this.log.error(handlerName, error);
                        }
                    });
                };
            }
        }
        this.log.info("setEventHandlers: handlers configured: ", this._eventHandlers);
    }
    /**
     * Clean event handler callbacks.
     *
     * We actually just reassign to the default callbacks.
     */
    _cleanEventHandlers() {
        this._eventHandlers = this._defaultHandlers;
        this._realEventHandlers = {};
    }
}
